module.exports = __webpack_public_path__ + "img/product_90.9d6a042.svg";